<template>
	<div class="dfc-source">
		<div class="center">
			<p class="description">下方是輔助您在進行 DFC 挑戰時會需要使用到的各項資料，建議您可直接下載紙本工具，方便與學生、家長、校方溝通。</p>
		</div>
		<el-table :data="presentList" fit stripe style="width: 100%; margin-top:40px;">
			<el-table-column prop="title" label="名稱" />
			<el-table-column prop="brief" label="簡介">
				<pre slot-scope="{row}">{{row.brief}}</pre>
			</el-table-column>
			<el-table-column align="center">
				<template slot-scope="{row}">
					<a :href="row.link" target="_blank">預覽</a>
				</template>
			</el-table-column>
			<!-- <el-table-column prop="frequency" label="下載次數" /> -->
		</el-table>
	</div>
</template>

<script>
const freeResource = require('@/data/free-resource.json');

export default {
	props: { page: Number, size: Number },
	data() {
		return {};
	},
	computed: {
		list: () => freeResource.challenge || [],
		presentList() {
			const from = (this.page - 1) * this.size;
			const to = from + this.size;
			return this.list.slice(from, to);
		}
	},
	methods: {},
	mounted() { },
	components: {}
};
</script>

<style lang="scss" scoped>
.dfc-source {
	.description {
		max-width: 435px;
		line-height: 1.5em;
		text-align: center;
	}
	.pagination {
		margin-top: 50px;

		.el-pagination {
			display: flex;
			justify-content: center;
		}
	}
}
</style>